import React from "react";
import PropTypes from "prop-types";
import ForgotPassword from "./forgotpassword.component";
import ForgotPasswordMobile from "./forgotpassword.componentMobile";

class FPScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileView: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    let currentHideNav = window.innerWidth <= 760;
    // console.log(currentHideNav);
    if (currentHideNav !== this.state.mobileView) {
      this.setState({ mobileView: currentHideNav });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  render() {
    return (
      <div>
        {this.state.mobileView ? <ForgotPasswordMobile /> : <ForgotPassword />}
      </div>
    );
  }
}

export default FPScreen;
